if (!customElements.get("collection-tabs")) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll(".collection-tabs__tab");
      this.tabPanels = this.querySelectorAll(".collection-tabs__tab-panel");
    }

    connectedCallback() {
      this.tabButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.activateTab(button);
        });
      });
    }

    activateTab(button) {
      const tabId = button.getAttribute("data-tab");
      const targetPanel = this.querySelector(`#${tabId}`);

      // Reset all tabs
      this.tabButtons.forEach((btn) => {
        btn.classList.remove("collection-tabs__tab--active");
        btn.setAttribute("aria-selected", "false");
        btn.setAttribute("tabindex", "-1");

        const bgImage = btn.querySelector(".collection-tabs__tab-background");
        if (bgImage) bgImage.classList.add("hidden");
      });

      // Reset all panels
      this.tabPanels.forEach((panel) => {
        panel.classList.remove("collection-tabs__tab-panel--active");
        panel.classList.add("hidden");
        panel.setAttribute("aria-hidden", "true");
      });

      // Activate clicked tab
      button.classList.add("collection-tabs__tab--active");
      button.setAttribute("aria-selected", "true");
      button.setAttribute("tabindex", "0");

      const activeBgImage = button.querySelector(
        ".collection-tabs__tab-background"
      );
      if (activeBgImage) activeBgImage.classList.remove("hidden");

      // Activate corresponding panel
      if (targetPanel) {
        targetPanel.classList.add("collection-tabs__tab-panel--active");
        targetPanel.classList.remove("hidden");
        targetPanel.setAttribute("aria-hidden", "false");

        // Refresh carousel components inside the active panel
        setTimeout(() => {
          const sliders = targetPanel.querySelectorAll("carousel-component");
          sliders.forEach((sliderElement) => {
            if (typeof sliderElement.refreshSlider === "function") {
              sliderElement.refreshSlider();
            }
          });
        }, 50);
      }
    }
  }

  customElements.define("collection-tabs", CollectionTabs);
}


// (function () {
//   if (!window.sectionData) return;

//   Object.values(window.sectionData).forEach(section => {
//     try {
//       var SECTION_ID = section.id;
//       var STORAGE_KEY = "ct-" + SECTION_ID + "-endTime";
//       var DEFAULT_HOURS = 9;
//       var now = Date.now();
//       var stored = localStorage.getItem(STORAGE_KEY);
//       var end = stored ? parseInt(stored, 10) : 0;
//       if (!end || isNaN(end) || end <= now) {
//         end = now + DEFAULT_HOURS * 60 * 60 * 1000;
//         localStorage.setItem(STORAGE_KEY, String(end));
//       }

//       function format(remainingMs) {
//         var totalSec = Math.max(0, Math.floor(remainingMs / 1000));
//         var h = Math.floor(totalSec / 3600);
//         var m = Math.floor((totalSec % 3600) / 60);
//         var s = totalSec % 60;
//         return (
//           h +
//           "h " +
//           String(m).padStart(2, "0") +
//           "m " +
//           String(s).padStart(2, "0") +
//           "s"
//         );
//       }

//       function update() {
//         var remaining = end - Date.now();
//         var badges = document.querySelectorAll(
//           ".collection-tabs-section-" + SECTION_ID + " .countdown-badge"
//         );
//         if (!badges.length) return;

//         if (remaining <= 0) {
//           end = Date.now() + DEFAULT_HOURS * 60 * 60 * 1000;
//           localStorage.setItem(STORAGE_KEY, String(end));
//           remaining = end - Date.now();
//         }

//         var text = format(remaining);
//         badges.forEach(function (el) {
//           var timeEl = el.querySelector("[data-time]");
//           if (timeEl) timeEl.textContent = text;
//         });
//       }

//       update();
//       var t = setInterval(update, 1000);
//     } catch (e) {
//       console &&
//         console.warn &&
//         console.warn("countdown error:", e);
//     }

//     // SECOND SCRIPT STARTS HERE
//     (function () {
//       var SECTION_ID = section.id;
//       var sectionElement = document.querySelector(
//         ".collection-tabs-section-" + SECTION_ID
//       );

//       if (!sectionElement) return;

//       // Function to refresh all carousels in a container
//       function refreshCarousels(container) {
//         var carousels = container.querySelectorAll("carousel-component");

//         carousels.forEach(function (carousel) {
//           // Wait a bit for the carousel to be fully visible
//           setTimeout(function () {
//             // Method 1: Try to access the Splide instance directly
//             if (
//               carousel.splide &&
//               typeof carousel.splide.refresh === "function"
//             ) {
//               carousel.splide.refresh();
//               return;
//             }

//             // Method 2: Try to find Splide instance in the element
//             if (
//               carousel.splideInstance &&
//               typeof carousel.splideInstance.refresh === "function"
//             ) {
//               carousel.splideInstance.refresh();
//               return;
//             }

//             // Method 3: Dispatch a custom event that the carousel component might listen to
//             carousel.dispatchEvent(
//               new CustomEvent("carousel:refresh", { bubbles: true })
//             );

//             // Method 4: Try to reinitialize if there's an init method
//             if (typeof carousel.init === "function") {
//               carousel.init();
//             }
//           }, 100);
//         });
//       }

//       // Watch for when the shimmer is hidden and carousel becomes visible
//       var observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//           if (
//             mutation.type === "attributes" &&
//             mutation.attributeName === "class"
//           ) {
//             var target = mutation.target;

//             // Check if the products slider just became visible
//             if (
//               target.classList.contains(
//                 "collection-tabs__tab-panels-products-slider"
//               ) &&
//               !target.classList.contains("hidden")
//             ) {
//               refreshCarousels(target);
//               // Stop observing after first reveal
//               observer.disconnect();
//             }
//           }
//         });
//       });

//       // Start observing the products slider container
//       var productsSlider = sectionElement.querySelector(
//         ".collection-tabs__tab-panels-products-slider"
//       );
//       if (productsSlider) {
//         observer.observe(productsSlider, {
//           attributes: true,
//           attributeFilter: ["class"],
//         });
//       }

//       // Also refresh carousels when tabs are switched
//       var tabButtons = sectionElement.querySelectorAll(".collection-tabs__tab");
//       tabButtons.forEach(function (button) {
//         button.addEventListener("click", function () {
//           setTimeout(function () {
//             var activePanel = sectionElement.querySelector(
//               ".collection-tabs__tab-panel--active"
//             );
//             if (activePanel) {
//               refreshCarousels(activePanel);
//             }
//           }, 150);
//         });
//       });

//       // Fallback: If carousel is already visible on load, refresh it
//       if (productsSlider && !productsSlider.classList.contains("hidden")) {
//         setTimeout(function () {
//           refreshCarousels(productsSlider);
//         }, 500);
//       }
//     })();
//   });
// })();
